import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  createStyles,
  makeStyles
} from '@material-ui/core';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {DEFAULT_WHITE_COLOR} from 'src/style/variable';

interface WelcomeScreenProps {
  open: boolean;
  onClose: () => void;
  practiceName: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    dialogActions: {
      paddingBottom: '1rem'
    },
    welcomeText: {
      fontSize: '1.75rem'
    },
    welcomeDialog: {
      '& .MuiBackdrop-root': {
        backgroundColor: DEFAULT_WHITE_COLOR
      }
    }
  })
);
function WelcomeScreen({
  open,
  onClose,
  practiceName
}: WelcomeScreenProps): JSX.Element {
  const {t} = useTranslation();
  const classes = useStyles();
  return (
    <Dialog
      maxWidth={'sm'}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={onClose}
      aria-labelledby="confirm-dialog"
      aria-describedby="confirm-dialog"
      className={classes.welcomeDialog}>
      <DialogContent>
        <DialogContentText style={{fontSize: '1.75rem'}}>
          {t('APPOINTMENTS_SCHEDULAR_PORTAL.WELCOME_SCREEN.WELCOME_MESSAGE')}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button variant={'contained'} onClick={onClose} color="primary">
          {t('APPOINTMENTS_SCHEDULAR_PORTAL.WELCOME_SCREEN.GET_STARTED')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WelcomeScreen;
